// Define all available permissions based on the backend API structure
export const PERMISSIONS = {
  // Employee Management
  EMPLOYEES_VIEW: 'EMPLOYEES_VIEW',
  EMPLOYEES_CREATE: 'EMPLOYEES_CREATE',
  EMPLOYEES_EDIT: 'EMPLOYEES_EDIT',
  EMPLOYEES_DELETE: 'EMPLOYEES_DELETE',

  DEPARTMENT_VIEW: 'DEPARTMENT_VIEW',
  DEPARTMENT_CREATE: 'DEPARTMENT_CREATE',
  DEPARTMENT_EDIT: 'DEPARTMENT_EDIT',
  DEPARTMENT_DELETE: 'DEPARTMENT_DELETE',

  // Hiring
  CANDIDATE_VIEW: 'CANDIDATE_VIEW',
  CANDIDATE_CREATE: 'CANDIDATE_CREATE',
  CANDIDATE_EDIT: 'CANDIDATE_EDIT',
  CANDIDATE_DELETE: 'CANDIDATE_DELETE',

  JOB_VIEW: 'JOB_VIEW',
  JOB_CREATE: 'JOB_CREATE',
  JOB_EDIT: 'JOB_EDIT',
  JOB_DELETE: 'JOB_DELETE',

  // Onboarding
  ONBOARDING_VIEW: 'ONBOARDING_VIEW',
  ONBOARDING_CREATE: 'ONBOARDING_CREATE',
  ONBOARDING_EDIT: 'ONBOARDING_EDIT',
  ONBOARDING_DELETE: 'ONBOARDING_DELETE',

  // Hiring Settings
  STATUS_VIEW: 'STATUS_VIEW',
  STATUS_CREATE: 'STATUS_CREATE',
  STATUS_EDIT: 'STATUS_EDIT',
  STATUS_DELETE: 'STATUS_DELETE',

  ONBOARDING_TASK_VIEW: 'ONBOARDING_TASK_VIEW',
  ONBOARDING_TASK_CREATE: 'ONBOARDING_TASK_CREATE',
  ONBOARDING_TASK_EDIT: 'ONBOARDING_TASK_EDIT',
  ONBOARDING_TASK_DELETE: 'ONBOARDING_TASK_DELETE',

  HIRING_SETTINGS_VIEW: 'HIRING_SETTINGS_VIEW',
  HIRING_SETTINGS_CREATE: 'HIRING_SETTINGS_CREATE',
  HIRING_SETTINGS_EDIT: 'HIRING_SETTINGS_EDIT',
  HIRING_SETTINGS_DELETE: 'HIRING_SETTINGS_DELETE',

  // Settings
  USER_VIEW: 'USER_VIEW',
  USER_CREATE: 'USER_CREATE',
  USER_EDIT: 'USER_EDIT',
  USER_DELETE: 'USER_DELETE',

  ROLE_VIEW: 'role.view',
  ROLE_CREATE: 'role.create',
  ROLE_EDIT: 'role.edit',
  ROLE_DELETE: 'role.delete',

  // Job Title Management
  JOB_TITLE_VIEW: 'jobTitle.view',
  JOB_TITLE_CREATE: 'jobTitle.create',
  JOB_TITLE_EDIT: 'jobTitle.edit',
  JOB_TITLE_DELETE: 'jobTitle.delete',

  // Agreement Management
  AGREEMENT_VIEW: 'agreement.view',
  AGREEMENT_CREATE: 'agreement.create',
  AGREEMENT_EDIT: 'agreement.edit',
  AGREEMENT_DELETE: 'agreement.delete',

  // Compensation Management
  COMPENSATION_VIEW: 'compensation.view',
  COMPENSATION_CREATE: 'compensation.create',
  COMPENSATION_EDIT: 'compensation.edit',
  COMPENSATION_DELETE: 'compensation.delete',

  // Project Management
  PROJECT_VIEW: 'project.view',
  PROJECT_CREATE: 'project.create',
  PROJECT_EDIT: 'project.edit',
  PROJECT_DELETE: 'project.delete',

  // Task Management
  TASK_VIEW: 'task.view',
  TASK_CREATE: 'task.create',
  TASK_EDIT: 'task.edit',
  TASK_DELETE: 'task.delete',

  // Sales Management
  SALES_VIEW: 'sales_management.client.view',
  PROPOSALS_VIEW: 'sales_management.proposal.view',
  CONTRACTS_VIEW: 'sales_management.contract.view',
  REVENUE_VIEW: 'sales_management.revenue.view',

  // Finance Management
  INVOICE_VIEW: 'finance_management.invoice.view',
  EXPENSE_VIEW: 'finance_management.expense.view',
  PAYROLL_VIEW: 'finance_management.payroll.view',
  FINANCE_REPORTS_VIEW: 'finance_management.financialReport.view',

  // System
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
} as const; 